import { Vehicle } from "../../types";

export const compareMeta = (vehicle: Vehicle) => {
  const key = vehicle.compare_key || String(vehicle.id);
  const [, type, value] = key.split(":");
  const base = `/vehicles/${vehicle.slug}`;
  let label: string | null = null;
  let detailUrl = base;
  if (type === "model" && value) {
    const m = vehicle.vehicle_models?.find((x) => x.slug === value);
    label = m ? m.name : value;
    detailUrl = `${base}/modeles/${value}`;
  } else if (type === "modele" && value) {
    // LEGACY : cles encore presentes dans les cookies d'une semaine. L'URL
    // ?modele= redirige en 301 vers la page de l'appellation, donc l'entree se
    // degrade en redirection et jamais en erreur.
    label = value;
    detailUrl = `${base}?modele=${encodeURIComponent(value)}`;
  } else if (type === "version" && value) {
    const v = vehicle.vehicle_versions?.find((x) => x.id.toString() === value);
    const m = vehicle.vehicle_models?.find(
      (x) => String(x.id) === String(v?.vehicle_model_id),
    );
    label = v
      ? m
        ? `${m.name} - ${v.sra_commercial}`
        : v.sra_commercial
      : null;
    // L'appellation, pas ?modele= : depuis ce chantier, ?modele= 301-redirige
    // vers l'appellation et le controleur jette alors un ?version= qui ne lui
    // appartient pas -- l'utilisateur atterrissait sur la mauvaise page.
    detailUrl = m
      ? `${base}/modeles/${m.slug}?version=${value}`
      : `${base}?version=${value}`;
  }
  return { key, label, detailUrl };
};
